<template>
  <div>
    <ChatIcon @toggle-popup="togglePopup" />
    <ChatPopup  :isOpen="!globalData.isPopupOpen" @close-popup="togglePopup" />
  </div>
</template>

<script>
import ChatIcon from '../components/ChatIcon.vue';
import ChatPopup from '../components/ChatPopup.vue';
import util from "@/lib/util";

export default {
  components: {
    ChatIcon,
    ChatPopup,
  },
  mounted() {
    this.socket.on('appendMessage', async data => {
      this.globalData.unread_count++;
      this.$root.$emit('addNewMessage', data);
      this.handleChangeSizeNotification();
    });
  },
  data() {
    return {
    };
  },
  methods: {
    togglePopup() {
      this.globalData.isPopupOpen = !this.globalData.isPopupOpen;
      let data = {
        type: 'change-size',
        data : this.globalData.isPopupOpen
      }
      window.parent.postMessage(data,  '*');
    },

    handleChangeSizeNotification() {
      if(!this.globalData.isPopupOpen){
        util.changeSizeNotification(this.globalData.unread_count);
        this.globalData.notify_content = 'Bạn có tin nhắn mới';
        this.globalData.is_show_notification = true;
        setTimeout(() => {
          this.globalData.is_show_notification = false;
          util.changeSizeNotification(0);
        }, 5000);
      }
    },
  },
};
</script>
